// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Logo-only navbar ── */
.adp-navbar {
  background: #ffffff;
  border-radius: 50px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10), inset 0 0 0 1.5px #B9B9B9;
  width: 97%;
  height: 100px;
  position: fixed;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 30px;
}

.adp-navbar-inner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* logo left on desktop */
}

.adp-navbar-logo {
  width: 220px;
  height: auto;
  display: block;
}

/* ── Page wrapper & Background ── */
.app-download-page {
  font-family: var(--font-montserrat);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(80deg, rgba(99, 24, 198, 0.15) 0%, rgba(227, 204, 0, 0.15) 100%);
  position: relative;
  overflow-x: hidden;
}

/* ── Sparkles ── */
.adp-sparkle {
  position: absolute;
  z-index: 1;
  pointer-events: none;
}

.adp-sparkle img {
  width: 24px;
  height: 24px;
  opacity: 0.6;
}

.adp-s1 {
  top: 150px;
  left: 10%;
}

.adp-s2 {
  top: 120px;
  right: 15%;
}

.adp-s3 {
  top: 250px;
  left: 5%;
}

.adp-s4 {
  bottom: 40%;
  right: 10%;
}

/* ── Vectors (fixed-vector.svg) ── */
.adp-vector {
  position: absolute;
  z-index: 1;
  pointer-events: none;
}

.adp-vector img {
  width: 26px;
  height: auto;
}

.adp-v1 {
  top: 213px;
  left: 27.5%;
}

.adp-v2 {
  top: 209px;
  right: 10%;
}

.adp-v3 {
  top: 370px;
  left: 7.5%;
}

.adp-v4 {
  top: 375px;
  right: 27%;
}

/* ── Main content area ── */
.adp-main {
  flex: 1 1;
  padding-top: 185px;
  padding-bottom: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  z-index: 2;
}

.adp-title {
  font-family: var(--font-montserrat-semibold);
  font-size: 48px;
  font-weight: 600;
  /* SemiBold */
  color: #101828;
  margin: 18px 0 16px 0;
  line-height: 1.2;
}

.adp-subtitle {
  font-family: var(--font-montserrat-medium);
  font-size: 32px;
  font-weight: 500;
  color: #101828;
  margin: 0 0 30px 0;
  line-height: 1.1;
  max-width: 754px;
}

/* ── Device images ── */
.adp-mockup-container {
  margin-bottom: 82px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.adp-device-img {
  width: 100%;
  max-width: 800px;
  height: auto;
  display: block;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.12));
}

.adp-desktop-only {
  display: block;
}

.adp-mobile-only {
  display: none;
}

/* ── Download Buttons ── */
.adp-buttons {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
}

.adp-dl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: #6318C6;
  border-radius: 26px;
  width: 350px;
  height: 120px;
  color: #fff !important;
  text-decoration: none !important;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(99, 24, 198, 0.25);
}

.adp-dl-btn:hover {
  background: #5213a6;
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(99, 24, 198, 0.35);
}

.adp-dl-btn-icon {
  width: 56px;
  height: 56px;
  filter: brightness(0) invert(1);
}

.adp-dl-btn-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.adp-dl-btn-small {
  font-size: 20px;
  font-weight: 500;
  font-family: var(--font-inter-medium);
  opacity: 0.9;
  line-height: 1.4;
}

.adp-dl-btn-big {
  font-size: 30px;
  font-weight: 600;
  font-family: var(--font-inter-semibold);
  line-height: 1;
}

/* ══════════════════════════════════
   MOBILE (≤767px)
══════════════════════════════════ */
@media (max-width: 767px) {
  .adp-subtitle {
    line-height: 1.5 !important;
    max-width: 264px !important;
  }

  .adp-navbar {
    height: 50px;
    border-radius: 33px;
    top: 10px;
    padding: 0 16px;
  }

  .adp-navbar-inner {
    justify-content: center;
  }

  .adp-navbar-logo {
    width: 126px;
  }

  .adp-main {
    padding-top: 100px;
    padding-bottom: 40px !important;
  }

  .adp-title {
    margin: 0 0 10px 0 !important;
  }

  .adp-title {
    font-size: 20px;
  }

  .adp-subtitle {
    font-size: 14px;
    margin-bottom: 25px;
  }

  .adp-mockup-container {
    margin-bottom: 32px;
  }

  .adp-desktop-only {
    display: none !important;
  }

  .adp-mobile-only {
    display: block !important;
  }

  .adp-device-img {
    max-width: 275px;
  }

  /* Buttons stack vertically on mobile */
  .adp-buttons {
    flex-direction: column;
    width: 100%;
    align-items: center;
    gap: 16px;
  }

  .adp-dl-btn {
    width: 160px;
    height: 48px;
    border-radius: 13.72px;
    gap: 8px;
  }

  .adp-dl-btn-icon {
    width: 30px;
    height: 30px;
  }

  .adp-dl-btn-small {
    font-size: 10px;
  }

  .adp-dl-btn-big {
    font-size: 15px;
  }

  /* .adp-vector {
    display: none;
  } */

  .adp-v1 {
    top: 72px;
    left: 5.5%;
  }

  .adp-v2 {
    top: 90px;
    right: 14%;
  }

  .adp-v3 {
    top: 155px;
    left: 11.5%;
  }

  .adp-v4 {
    top: 202px;
    right: 12%;
  }

  .adp-vector img {
    width: 14px;
    height: auto;
  }

  /* Footer mobile tweaks */
  .adp-footer-links-row {
    flex-direction: row;
    font-size: 14px;
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/AppDownloadPage/AppDownloadPage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qEAAqE;EACrE,UAAU;EACV,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,4FAA4F;EAC5F,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;;oCAEoC;AACpC;EACE;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":["/* ── Logo-only navbar ── */\n.adp-navbar {\n  background: #ffffff;\n  border-radius: 50px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10), inset 0 0 0 1.5px #B9B9B9;\n  width: 97%;\n  height: 100px;\n  position: fixed;\n  top: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  padding: 0 30px;\n}\n\n.adp-navbar-inner {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  /* logo left on desktop */\n}\n\n.adp-navbar-logo {\n  width: 220px;\n  height: auto;\n  display: block;\n}\n\n/* ── Page wrapper & Background ── */\n.app-download-page {\n  font-family: var(--font-montserrat);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(80deg, rgba(99, 24, 198, 0.15) 0%, rgba(227, 204, 0, 0.15) 100%);\n  position: relative;\n  overflow-x: hidden;\n}\n\n/* ── Sparkles ── */\n.adp-sparkle {\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.adp-sparkle img {\n  width: 24px;\n  height: 24px;\n  opacity: 0.6;\n}\n\n.adp-s1 {\n  top: 150px;\n  left: 10%;\n}\n\n.adp-s2 {\n  top: 120px;\n  right: 15%;\n}\n\n.adp-s3 {\n  top: 250px;\n  left: 5%;\n}\n\n.adp-s4 {\n  bottom: 40%;\n  right: 10%;\n}\n\n/* ── Vectors (fixed-vector.svg) ── */\n.adp-vector {\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.adp-vector img {\n  width: 26px;\n  height: auto;\n}\n\n.adp-v1 {\n  top: 213px;\n  left: 27.5%;\n}\n\n.adp-v2 {\n  top: 209px;\n  right: 10%;\n}\n\n.adp-v3 {\n  top: 370px;\n  left: 7.5%;\n}\n\n.adp-v4 {\n  top: 375px;\n  right: 27%;\n}\n\n/* ── Main content area ── */\n.adp-main {\n  flex: 1;\n  padding-top: 185px;\n  padding-bottom: 110px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding-left: 20px;\n  padding-right: 20px;\n  position: relative;\n  z-index: 2;\n}\n\n.adp-title {\n  font-family: var(--font-montserrat-semibold);\n  font-size: 48px;\n  font-weight: 600;\n  /* SemiBold */\n  color: #101828;\n  margin: 18px 0 16px 0;\n  line-height: 1.2;\n}\n\n.adp-subtitle {\n  font-family: var(--font-montserrat-medium);\n  font-size: 32px;\n  font-weight: 500;\n  color: #101828;\n  margin: 0 0 30px 0;\n  line-height: 1.1;\n  max-width: 754px;\n}\n\n/* ── Device images ── */\n.adp-mockup-container {\n  margin-bottom: 82px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.adp-device-img {\n  width: 100%;\n  max-width: 800px;\n  height: auto;\n  display: block;\n  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.12));\n}\n\n.adp-desktop-only {\n  display: block;\n}\n\n.adp-mobile-only {\n  display: none;\n}\n\n/* ── Download Buttons ── */\n.adp-buttons {\n  display: flex;\n  gap: 24px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.adp-dl-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  background: #6318C6;\n  border-radius: 26px;\n  width: 350px;\n  height: 120px;\n  color: #fff !important;\n  text-decoration: none !important;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 8px 24px rgba(99, 24, 198, 0.25);\n}\n\n.adp-dl-btn:hover {\n  background: #5213a6;\n  transform: translateY(-4px);\n  box-shadow: 0 12px 32px rgba(99, 24, 198, 0.35);\n}\n\n.adp-dl-btn-icon {\n  width: 56px;\n  height: 56px;\n  filter: brightness(0) invert(1);\n}\n\n.adp-dl-btn-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.adp-dl-btn-small {\n  font-size: 20px;\n  font-weight: 500;\n  font-family: var(--font-inter-medium);\n  opacity: 0.9;\n  line-height: 1.4;\n}\n\n.adp-dl-btn-big {\n  font-size: 30px;\n  font-weight: 600;\n  font-family: var(--font-inter-semibold);\n  line-height: 1;\n}\n\n/* ══════════════════════════════════\n   MOBILE (≤767px)\n══════════════════════════════════ */\n@media (max-width: 767px) {\n  .adp-subtitle {\n    line-height: 1.5 !important;\n    max-width: 264px !important;\n  }\n\n  .adp-navbar {\n    height: 50px;\n    border-radius: 33px;\n    top: 10px;\n    padding: 0 16px;\n  }\n\n  .adp-navbar-inner {\n    justify-content: center;\n  }\n\n  .adp-navbar-logo {\n    width: 126px;\n  }\n\n  .adp-main {\n    padding-top: 100px;\n    padding-bottom: 40px !important;\n  }\n\n  .adp-title {\n    margin: 0 0 10px 0 !important;\n  }\n\n  .adp-title {\n    font-size: 20px;\n  }\n\n  .adp-subtitle {\n    font-size: 14px;\n    margin-bottom: 25px;\n  }\n\n  .adp-mockup-container {\n    margin-bottom: 32px;\n  }\n\n  .adp-desktop-only {\n    display: none !important;\n  }\n\n  .adp-mobile-only {\n    display: block !important;\n  }\n\n  .adp-device-img {\n    max-width: 275px;\n  }\n\n  /* Buttons stack vertically on mobile */\n  .adp-buttons {\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .adp-dl-btn {\n    width: 160px;\n    height: 48px;\n    border-radius: 13.72px;\n    gap: 8px;\n  }\n\n  .adp-dl-btn-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .adp-dl-btn-small {\n    font-size: 10px;\n  }\n\n  .adp-dl-btn-big {\n    font-size: 15px;\n  }\n\n  /* .adp-vector {\n    display: none;\n  } */\n\n  .adp-v1 {\n    top: 72px;\n    left: 5.5%;\n  }\n\n  .adp-v2 {\n    top: 90px;\n    right: 14%;\n  }\n\n  .adp-v3 {\n    top: 155px;\n    left: 11.5%;\n  }\n\n  .adp-v4 {\n    top: 202px;\n    right: 12%;\n  }\n\n  .adp-vector img {\n    width: 14px;\n    height: auto;\n  }\n\n  /* Footer mobile tweaks */\n  .adp-footer-links-row {\n    flex-direction: row;\n    font-size: 14px;\n    gap: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
